import { ReactElement } from 'react';
import { Component as ArrowRightIcon } from 'icons/icon-ui--chevron-right.svg';
import { SignupStep } from '../../constants/signup';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import styles from './SignupDrawer.module.scss';

const STEP_ORDER = [
  {
    step: SignupStep.CREATE_ACCOUNT,
    label: 'Account',
  },
  {
    step: SignupStep.SHIPPING_ADDRESS,
    label: 'Shipping',
  },
  {
    step: SignupStep.PAYMENT,
    label: 'Payment',
  },
];

export function SignupProgressStepper(): ReactElement {
  const {
    setCurrentSignupStep,
    currentSignupStep,
  } = useMenuWithCart();

  // Get index of current step
  const currentStepIndex = STEP_ORDER.findIndex(
    ({ step }) => step === currentSignupStep,
  );

  return (
    <div className={styles.progress_stepper_container_wrapper}>
      {STEP_ORDER.map(({
        step,
        label,
      }, stepIndex) => {
        // Only allow clicking for completed steps
        const isClickable = stepIndex < currentStepIndex;

        return (
          <div key={step} className={styles.progress_stepper_container}>
            <div
              className={`${styles.progress_stepper}  ${currentSignupStep === step ? styles.is_active : ''}`}
              style={{
                cursor: isClickable ? 'pointer' : 'default',
                fontWeight: isClickable ? 'bold' : undefined,
              }}
              onClick={() => {
                if (isClickable) {
                  setCurrentSignupStep(step);
                }
              }}
            >
              {stepIndex + 1}
              {' '}
              •
              {' '}
              {label}
            </div>

            {stepIndex < STEP_ORDER.length - 1 && (
              <ArrowRightIcon className={styles.progress_stepper_arrow} />
            )}
          </div>
        );
      })}
    </div>
  );
}
